import axios from "axios";
import {Result} from "@zhoujianhui/vip-core";
import authManager from "@zhoujianhui/vip-core/src/manager/auth-manager";

const enterpriseManager = {
    currentUserEnterpriseInfo: {},
    enterpriseCertification: false,

    /**
     * 设置当前用户的企业信息
     * 当登录成功、刷新页面、企业认证成功，会设置当前用户的企业信息
     */
    async setCurrentUserEnterpriseInfo() {
        if (authManager.isAuthenticated()) {
            const result = await this.searchCurrentUserEnterpriseInfo();
            if (result.isSuccess() && result.data) {
                this.currentUserEnterpriseInfo = result.data;
                this.setEnterpriseCertification(true);
            } else {
                this.currentUserEnterpriseInfo = {};
                this.setEnterpriseCertification(false);
            }
        }
    },

    /**
     * 获取当前登录用户的企业信息
     * @returns 登录用户的企业信息
     */
    getCurrentUserEnterpriseInfo() {
        return this.currentUserEnterpriseInfo;
    },


    isEnterpriseCertification() {
        return this.enterpriseCertification;
    },
    setEnterpriseCertification(enterpriseCertification) {
        this.enterpriseCertification = enterpriseCertification;
    },


    ///////////////

    /**
     * 查询当前登录用户的企业信息
     * @returns {Promise<*>}
     */
    async searchCurrentUserEnterpriseInfo() {
        try {
            const response = await axios.get("/enterprise-info");
            return Result.success("查询当前登录用户的企业成功！").data(response.data).build();
        } catch (error) {
            return Result.error("查询当前登录用户的企业失败！").build();
        }
    }
}
export default enterpriseManager